module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Copyright © 2001 by Laura Lee Fritz")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Development Editor: Cyndy Lyle Rymer")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Technical Editor: Sara Kate MacFarland")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Copy Editor: Carol Barrett")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Book Design: Staci Harpole, Cubic Design")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Cover Design: Kris Yenche")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Graphic Illustrations: Kate Reed")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Design Direction: Diane Pedersen")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Production Assistant: Stephanie Muir")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Photography: Steven Buckley, Photographic Reflections")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Front Cover and Title Page Photos: Quilted images by")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("Laura Lee Fritz, photo by Bagley Tauber Photography")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Back Cover Photo: "), _c('i', [_vm._v("A Woodland Tale")]), _vm._v(" by Laura Lee Fritz, 60”")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("x 80”, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this work covered by the copyright hereon may be reproduced or used in any form or by any means—graphic, electronic, or mechanical, including photocopying, recording, taping, or information storage and retrieval system—without written permission of the publisher. Exception: The publisher gives permission to photocopy—including reductions and enlargements—all pages (except pages 33-40) for personal use only.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Trademarked ™ and Registered Trademarked ® names are used throughout this book. Rather than use the symbols with every occurrence of a trademark and registered trademark name, we have only used the symbol the first time the product appears. We are using the names only in an editorial fashion and to the benefit of the owner, with no intention of infringement.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("We take great care to ensure that the information included in this book is accurate and presented in good faith, but no warranty is provided nor results guaranteed. Since we have no control over the choice of materials or procedures used, neither the author nor C&T Publishing, Inc. shall have any liability to any person or entity with respect to any loss or damage caused directly or indirectly by the information contained in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Attention Teachers:")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("C&T Publishing, Inc. encourages you to use this book as a text for teaching. Contact us at 800-284-1114 or "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://www.ctpub.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.ctpub.com")])])]), _vm._v(" for more information about the C&T Teachers Program.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published by C&T Publishing, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("P.O. Box 1456")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Lafayette, California 94549")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Fritz, Laura Lee.")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("250 continuous-line quilting designs for hand, machine & long-arm quilters / Laura Lee Fritz.")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("ISBN 1-57120-171-8")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("1. Quilting. 2. Quilts—Design. I. Title: Two hundred fifty continuous-line quilting designs for hand, machine & long-arm quilters.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("II. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("TT835 .F756 2001")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("746.46’041—dc21")]), _vm._v(" "), _c('p', {
    staticClass: "copy4"
  }, [_vm._v("2001002357")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e620bc9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 63
// module chunks = 0